import { baseService } from '@repo/services';
import { type AutomationConfig } from 'automations/types/automationConfig';

const automationConfigService = baseService.injectEndpoints({
  endpoints: (build) => ({
    getAutomationConfig: build.query<AutomationConfig, void>({
      query: () => ({
        method: 'GET',
        url: '/v1/automations/configs',
      }),
    }),
  }),
});

export const {
  useGetAutomationConfigQuery,
} = automationConfigService;
